import { Box } from "@mui/material";
import React from "react";
import { useStyles } from "./styles";

const KpiCard = ({ children, height = "100%", sx = {} }) => {
  const classes = useStyles();
  return (
    <Box sx={sx} className={classes.root} height={height} px={2.5} py={2}>
      {children}
    </Box>
  );
};

export default KpiCard;
